import { ApiErrorCode, withApiErrorHandler } from '@/modules/common/api/errors';
import { DemoStatusResponse } from '@/modules/demo/types';
import { axiosInstance } from '@/utils/axios';

const DEMO_STATUS_ENDPOINT = '/api/demo/status';

/**
 * Fetches demo environment status including days left in trial.
 * @returns Demo status with days left
 */
export const getDemoStatus = async (): Promise<DemoStatusResponse> => {
  return withApiErrorHandler(DEMO_STATUS_ENDPOINT, ApiErrorCode.DEMO_STATUS_LOAD_FAILED, () =>
    axiosInstance.get<{ data: DemoStatusResponse }>(DEMO_STATUS_ENDPOINT)
  );
};
